<template>
  <div class="app-container delivery-setting-page">
    <BjDivider>
      {{ $t('BusinessLogisticsProductLang.productEdit') }}
      <template slot="right">
        <el-button @click="onCancel()">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>

    <section class="setting-card summary-card">
      <div v-for="item in summaryItems" :key="item.labelKey" class="summary-item">
        <span class="summary-label">{{ $t(item.labelKey) }}:</span>
        <el-tag v-if="item.tagType" size="mini" :type="item.tagType">{{ item.value }}</el-tag>
        <span v-else class="summary-value">{{ item.value || '' }}</span>
      </div>
    </section>

    <section class="setting-card config-card">
      <el-tabs v-model="activeTab" class="setting-tabs">
        <el-tab-pane v-for="tab in tabs" :key="tab.name" :name="tab.name" :label="$t(tab.labelKey)" :disabled="tab.disabled">
          <div v-if="tab.name === 'zone'" class="tab-pane-body">
            <el-form ref="zoneForm" :model="zoneForm" :rules="zoneRules" label-position="top" class="zone-form">
              <el-form-item :label="$t('BusinessLogisticsProductLang.serviceZone')" prop="customerLogisticsGroupDictServiceId">
                <BjSelectLov v-model="zoneForm.customerLogisticsGroupDictServiceId" :option-list="zoneOptions1" :placeholder="$t('BusinessLogisticsProductLang.serviceZone')" />
              </el-form-item>
              <el-form-item :label="$t('BusinessLogisticsProductLang.remoteZone')" prop="customerLogisticsGroupDictRemoteId">
                <BjSelectLov v-model="zoneForm.customerLogisticsGroupDictRemoteId" :option-list="zoneOptions2" :placeholder="$t('BusinessLogisticsProductLang.remoteZone')" />
              </el-form-item>
            </el-form>
          </div>
          <div v-else class="tab-pane-body" />
        </el-tab-pane>
      </el-tabs>
    </section>

    <div class="footer-actions">
      <el-button class="footer-btn" @click="onCancel">{{ $t('cancelText') }}</el-button>
      <el-button class="footer-btn" type="primary" @click="onSubmit">{{ $t('okText') }}</el-button>
    </div>
  </div>
</template>

<script>
import { logisticApi } from '@/api';
import { STATUS_ENABLED_TRUE } from '@/utils/constants';
import { getLanguage } from '@/lang/index';
import { quotationTimeFilter } from '@/filters';

export default {
  name: 'BusinessLogisticsProductSetting',
  data() {
    return {
      language: getLanguage(),
      STATUS_ENABLED_TRUE,
      activeTab: 'zone',
      PRODUCT_ALL_TYPE_LIST: [],
      detail: {
        productCode: null,
        productName: null,
        productType: null,
        supplierName: null,
        status: null,
        creationDate: null,
      },
      tabs: [
        { name: 'productRule', labelKey: 'BusinessLogisticsProductLang.productRules', disabled: true },
        { name: 'labelRule', labelKey: 'BusinessLogisticsProductLang.labelRules', disabled: true },
        { name: 'trackingNo', labelKey: 'BusinessLogisticsProductLang.deliveryTrackingNumberSettings', disabled: true },
        { name: 'zone', labelKey: 'BusinessLogisticsProductLang.zones', disabled: false },
        { name: 'trackingFetch', labelKey: 'BusinessLogisticsProductLang.trackingDataFetchSettings', disabled: true },
      ],
      // 分区tab页表单数据
      zoneForm: {
        customerLogisticsGroupDictServiceId: null,
        customerLogisticsGroupDictRemoteId: null,
      },
      // 分区tab页下拉选项
      zoneOptions1: [],
      zoneOptions2: [],
    };
  },
  computed: {
    // 详情页 顶部数据
    summaryItems() {
      const detail = this.detail || {};
      return [
        { labelKey: 'BusinessLogisticsProductLang.productCode', value: detail.productCode },
        { labelKey: 'BusinessLogisticsProductLang.productName', value: detail.productName },
        { labelKey: 'BusinessLogisticsProductLang.productType', value: this.$t(this.PRODUCT_ALL_TYPE_LIST.bjGet(this.detail.productType)) },
        { labelKey: 'BusinessLogisticsProductLang.supplier', value: detail.supplierName },
        { labelKey: 'BusinessLogisticsProductLang.status', value: this.statusText, tagType: detail.status ? 'success' : 'info' },
        { labelKey: 'BusinessLogisticsProductLang.createdOn', value: quotationTimeFilter(detail.creationDate) },
      ];
    },
    // 详情页 顶部状态
    statusText() {
      if (this.detail.status === null || this.detail.status === undefined) {
        return '';
      }
      return this.$t(this.STATUS_ENABLED_TRUE.bjGet(this.detail.status));
    },
    // 分区tab页表单校验规则
    zoneRules() {
      return {
        customerLogisticsGroupDictServiceId: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      };
    },
  },
  mounted() {
    logisticApi.getLogisticProductTypeList({groupCode: 'LOG_PRODUCT_TYPE'}).then(res => {
      if (!res.failed) {
        this.PRODUCT_ALL_TYPE_LIST = (res || []).map(item => ({
          label: this.language === 'zh' ? item.valueName : item.valueNameEn,
          value: item.valueCode
        }));
      }
    });
    // 获取页面顶部详情数据
    this.loadDetail();
    // 获取分区下拉选项
    this.loadZoneOptions();

    // 获取分区tab页表单数据回显 先在这里使用，后续其他tab页可点击后在点击方法调用
    this.loadZoneFormData();
  },
  methods: {
    // 获取页面顶部详情数据
    loadDetail() {
      const id = this.$route.query && this.$route.query.id;
      if (!id) return;
      logisticApi.getLogisticProductSettingInfo({ id }).then(res => {
        if (res && res.failed) return;
        const detail = this.normalizeContent(res);
        this.detail = {
          ...this.detail,
          ...detail,
          status: detail.status == '1',
        };
      });
    },
    // 非空处理，返回对象
    normalizeContent(res) {
      if (!res) return {};
      const content = res && res.content;
      if (content === undefined) return res;
      if (Array.isArray(content)) return content[0] || {};
      if (content && Array.isArray(content.content)) return content.content[0] || {};
      if (content && Array.isArray(content.records)) return content.records[0] || {};
      return content || {};
    },
    // 获取分区下拉选项
    loadZoneOptions() {
      logisticApi.getLogisticGroupList({zoneGroupType: '1'}).then(res => {
        if (!res.failed) {
          this.zoneOptions1 = (res.content || []).map(item => ({
            label: item.logisticsGroupName,
            value: item.id,
          }));
        }
      });
      logisticApi.getLogisticGroupList({zoneGroupType: '2'}).then(res => {
        if (!res.failed) {
          this.zoneOptions2 = (res.content || []).map(item => ({
            label: item.logisticsGroupName,
            value: item.id,
          }));
        }
      });
    },
    // 获取分区tab页表单数据回显
    loadZoneFormData() {
      const id = this.$route.query && this.$route.query.id;
      if (!id) return;
      logisticApi.getCustomerLogisticsGroupDict({ businessId: id }).then(res => {
        if (!res) return;
        this.zoneForm.customerLogisticsGroupDictServiceId = res.customerLogisticsGroupDictServiceId || null;
        this.zoneForm.customerLogisticsGroupDictRemoteId = res.customerLogisticsGroupDictRemoteId || null;
      });
    },
    // 返回之前 列表页
    onCancel() {
      this.$router.push({
        name: 'BusinessLogisticsProduct',
      });
    },
    // 获取分区tab页表单ref
    getZoneFormRef() {
      const zoneForm = this.$refs.zoneForm;
      return Array.isArray(zoneForm) ? zoneForm[0] : zoneForm;
    },
    // 分区tab页表单提交
    onSubmit() {
      const zoneForm = this.getZoneFormRef();
      if (!zoneForm) return;
      zoneForm.validate(valid => {
        if (valid) {
          const id = this.$route.query && this.$route.query.id;
          logisticApi.setCustomerLogisticsGroupDict({ ...this.zoneForm, businessId: id }).then(res => {
            if (!res.failed) {
              this.$message.success(this.$t('toast.operationSuccessText'));
              // 重新获取分区tab页表单数据回显
              this.loadZoneOptions();
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-setting-page {
  box-sizing: border-box;
  min-height: calc(100vh - 84px);
  padding: 18px;
  background: #f5f6f8;
}

.setting-card {
  border: 1px solid #dfe3eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(16, 24, 40, 0.04);
}

.summary-card {
  display: grid;
  grid-template-columns: repeat(3, minmax(260px, 1fr));
  gap: 24px 96px;
  margin-bottom: 12px;
  padding: 28px 40px;
}

.summary-item {
  display: flex;
  align-items: center;
  min-width: 0;
  color: #344054;
  font-size: 14px;
  line-height: 24px;
}

.summary-label {
  flex: 0 0 auto;
  margin-right: 8px;
  color: #7a8699;
}

.summary-value {
  min-width: 0;
  overflow: hidden;
  color: #344054;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.config-card {
  padding: 0;
}

.setting-tabs {
  padding: 18px 24px 20px;
}

.tab-pane-body {
  height: calc(100vh - 560px);
  min-height: 320px;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.zone-form {
  width: 472px;
}

.footer-actions {
  display: flex;
  justify-content: center;
  gap: 26px;
  padding: 18px 0 0;
}

.footer-btn {
  width: 160px;
  height: 40px;
}

@media (max-width: 1200px) {
  .summary-card {
    grid-template-columns: repeat(2, minmax(240px, 1fr));
    gap: 20px 56px;
  }
}
</style>
